import React from 'react'
import styled from 'styled-components'
// import { Card } from '@pancakeswap/uikit'

export const BodyWrapper = styled.div`
  background: ${({ theme }) => theme.colors.background};
  border-radius: 20px;
  box-shadow: 0 0 12px 2px ${({ theme }) => theme.colors.cardBorder};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  max-width: 427px;
  width: 100%;
  z-index: 1;
  button {
    border-radius: 5px;
    font-weight: normal;
    border-width: 1px;
  }
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  return <BodyWrapper >{children}</BodyWrapper>
}
